<template>
  <popup-block
    v-if="popup.isOpen"
    :open="popup.isOpen"
    :size="'small'"
    @close="popup.isOpen = false;"
  >
    <template slot="popupContent">
      <div class="sm-notary-success">
        <h4>{{popup.notary}} is successfully sent to notary service</h4>
        <p>Please check your email to see further instructions</p>
        <btn-block 
          :text="'Ok'"
          @click="popup.isOpen = false"
        />
      </div>
    </template>
  </popup-block>
</template>

<script>
import Popup from '@/components/Popup';

export default {
  name: 'notary-success',
  components: {
    'popup-block': Popup
  },
  data() {
    return {
      popup: {
        isOpen: false,
        notary: ''
      }
    };
  },
  created() {
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      let query = Object.assign({}, this.$route.query);

      if (query.signed) {
        this.popup.notary = query.signed.charAt(0).toUpperCase() + query.signed.slice(1);
        this.popup.isOpen = true;
        
        delete query.signed;
        this.$router.push({query});
      }
    }
  },
  watch: {
    $route(to, from) {
      this.checkQuery();
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;

  .sm-notary-success {
    & > p {
      margin-top: 16px;
    }

    & > button {
      display: block;
      margin: 36px auto 0;

      @include media('<=tiny') {
        width: 100%;
        margin-top: 32px;
      }
    }
  }
</style>